import '../trust/index.js';
import inlineSVG from '@gearset/web-core/scripts/inlineSvg.js';
import calendly from 'Scripts/calendly.js';

document.addEventListener('DOMContentLoaded', () => {
	/* Load SVGs inline, so we can colour them */
	inlineSVG.init({
		svgSelector: 'img.svg',
		initClass: 'js-inlinesvg',
	});

	calendly.setUpCalendly();
});
